import { render, staticRenderFns } from "./VaimoAccountSidebar.vue?vue&type=template&id=33685210&scoped=true&"
import script from "./VaimoAccountSidebar.vue?vue&type=script&lang=ts&"
export * from "./VaimoAccountSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoAccountSidebar.vue?vue&type=style&index=0&id=33685210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33685210",
  null
  
)

export default component.exports